// extracted by mini-css-extract-plugin
module.exports = {"title":"frequencyGraph_title__hvTNt","subtitle":"frequencyGraph_subtitle__3l0lF"};